import { selectAssetById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo, type MouseEventHandler, useCallback } from "react"

import { useViewGeometryOnMap } from "../../mapbox/hooks"
import { useAppSelector } from "../../store"
import type { ExtendableLinkProps } from "./typings"

export interface AssetLinkProps extends ExtendableLinkProps {
	assetId: string
}

export const AssetLink = memo<AssetLinkProps>((props) => {
	const { assetId, ref, onClick, ...rest } = props

	const asset = useAppSelector(selectAssetById(assetId))

	if (!asset) {
		throw new Error(`Asset with id ${assetId} not found`)
	}

	const viewAssetOnMap = useViewGeometryOnMap()

	const handleClick = useCallback<MouseEventHandler<HTMLAnchorElement>>(
		(e) => {
			onClick?.(e)

			if (e.defaultPrevented) return

			viewAssetOnMap(asset.geometry)
		},
		[asset, onClick, viewAssetOnMap],
	)

	const params = useCallback(
		(prev) => {
			return {
				...prev,
				assetId: assetId,
			}
		},
		[assetId],
	)

	return (
		<Link
			ref={ref}
			to="/$organizationId/$projectId/assets/$assetId"
			params={params}
			onClick={handleClick}
			{...rest}
		/>
	)
})
AssetLink.displayName = "AssetLink"
